jQuery(function($) {
  //   メニューボタン
  $('.site-header .menu-btn').on('click', function() {
	$(this).toggleClass('open');
    $(this).next('.mobile-menu').toggleClass('open');
    $(this).closest('.header-container').toggleClass('open');
    $('body').toggleClass('open');
  });
  
  // 商品詳細ドロップダウン  
//   $('.tag-list .tag-list-item').hover(function() {
//       $("ul:not(:animated)", this).slideDown();
//   }, function() {
//       $("ul.tag-inner-list",this).slideUp();
//   });

  $('.tag-list .tag-list-item').on('click', function() {
	$(this).children('.tag-inner-list').slideToggle();
    $(this).toggleClass('open');
    $('.tag-list .tag-list-item').not($(this)).children('.tag-list-item .tag-inner-list').slideUp();
    $('.tag-list .tag-list-item').not($(this)).removeClass('open');
  });
 
});